import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';

// Define your custom light theme
const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#ffff',
  },
};

// Create Vuetify instance
export default createVuetify({
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
  display: {
    mobileBreakpoint: 'sm', // Define breakpoints here
    thresholds: {
      xs: 0,
      sm: 340,
      md: 540,
      lg: 800,
      xl: 1280,
    },
  },
});
